import { InsuranceOptions, PracticeTypes } from "../../constants";
const DentistEnrollmentServiceInfo = ({
  formData,
  handleChange,
  handleMultiSelect,
  onBack,
  handleFileChange,
  handleRemoveFile,
  errors
}) => {
  return (
    <>
      <div
        className={`pi-box-purple p-4 rounded-3 mb-4 ${
          errors.practiceTypes ? "border border-danger" : ""
        }`}
      >
        <p className="fw-bold mb-3" style={{ color: "#d6258f" }}>
          Practice Type <span className="text-danger">*</span>
        </p>
        <p className="small text-muted mb-3">
          Check all that apply to your practice
        </p>

        <div className="bg-white p-3 rounded-3 shadow-sm">
          <div className="d-flex flex-column gap-2">
            {PracticeTypes.map((type) => (
              <div className="form-check" key={type}>
                <input
                  className="form-check-input"
                  type="checkbox"
                  value={type}
                  id={`type-${type}`}
                  checked={formData.practiceTypes.includes(type)}
                  onChange={(e) => handleMultiSelect(e, "practiceTypes")}
                />
                <label
                  className="form-check-label small"
                  htmlFor={`type-${type}`}
                >
                  {type}
                </label>
              </div>
            ))}
          </div>
        </div>
        {errors.practiceTypes && (
          <div className="text-danger small mt-2 fw-bold">
            {errors.practiceTypes}
          </div>
        )}
      </div>

      <div className="pi-box-green p-4 rounded-3 mb-4">
        <p className="fw-bold mb-3 text-success">Insurance Accepted</p>
        <p className="small text-muted mb-3">
          Select all insurance plans your practice accepts
        </p>
        <div className="bg-white p-3 rounded-3 shadow-sm">
          <div className="d-flex flex-column gap-2">
            {InsuranceOptions.map((ins) => (
              <div className="form-check" key={ins}>
                <input
                  className="form-check-input"
                  type="checkbox"
                  value={ins}
                  id={`ins-${ins}`}
                  checked={formData.insurances.includes(ins)}
                  onChange={(e) => handleMultiSelect(e, "insurances")}
                />
                <label
                  className="form-check-label small"
                  htmlFor={`ins-${ins}`}
                >
                  {ins}
                </label>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="pi-box-yellow p-4 rounded-3 mb-5">
        <p className="fw-bold mb-3 text-warning-dark">Optional Enhancements</p>
        <p className="small text-muted mb-3">
          These fields help surface the practice to more relevant patients
        </p>

        <div className="bg-white p-3 rounded-3 shadow-sm">
          <div className="mb-3">
            <label className="form-label small fw-bold text-muted">
              Languages Spoken
            </label>
            <input
              type="text"
              className="form-control"
              name="languages"
              placeholder="e.g., English, Spanish"
              value={formData.languages}
              onChange={handleChange}
            />
          </div>

          <div className="mb-4">
            <label className="form-label small fw-bold text-muted mb-1">
              Photos of Office or Team
            </label>
            <p className="small text-muted mb-2">Upload up to 3 photos</p>

            <div
              className="border border-2 rounded-3 p-3 text-center bg-white position-relative mb-3"
              style={{ borderColor: "#e0e0e0", borderStyle: "dashed" }}
            >
              <div className="d-flex align-items-center justify-content-center gap-2 py-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#9d3bf0"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                  <polyline points="17 8 12 3 7 8"></polyline>
                  <line x1="12" y1="3" x2="12" y2="15"></line>
                </svg>
                <span
                  className="fw-normal"
                  style={{ color: "#333", fontSize: "14px" }}
                >
                  Click to upload photos
                </span>
              </div>

              <input
                type="file"
                multiple
                accept="image/*"
                className="position-absolute top-0 start-0 w-100 h-100 opacity-0"
                style={{ cursor: "pointer" }}
                onChange={handleFileChange}
              />
            </div>

            {formData.photos && formData.photos?.length > 0 && (
              <div className="d-flex flex-column gap-2">
                {formData.photos.map((file, index) => (
                  <div
                    key={index}
                    className="d-flex align-items-center justify-content-between p-3 bg-white border rounded shadow-sm"
                  >
                    <span
                      className="text-truncate text-dark small"
                      style={{ maxWidth: "85%" }}
                    >
                      {file.name}
                    </span>
                    <span
                      className="text-danger fw-bold small"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleRemoveFile(index)}
                    >
                      Remove
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
          <div>
            <label className="form-label small fw-bold text-muted">
              Contact for Follow-Up
            </label>
            <div className="form-check mb-3">
              <input
                className="form-check-input"
                type="checkbox"
                name="doNotContact"
                id="doNotContact"
                checked={formData.doNotContact}
                onChange={handleChange}
              />
              <label className="form-check-label small" htmlFor="doNotContact">
                Do not contact me
              </label>
            </div>
            <div
              className={`row g-2 ${formData.doNotContact ? "opacity-50" : ""}`}
            >
              <div className="col-md-4">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Name"
                  name="contactName"
                  disabled={formData.doNotContact}
                  onChange={handleChange}
                  value={formData.contactName}
                />
              </div>
              <div className="col-md-4">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Role"
                  name="contactRole"
                  disabled={formData.doNotContact}
                  onChange={handleChange}
                  value={formData.contactRole}
                />
              </div>
              <div className="col-md-4">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Best time to reach"
                  name="contactTime"
                  disabled={formData.doNotContact}
                  onChange={handleChange}
                  value={formData.contactTime}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="text-center">
        <button
          type="button"
          onClick={onBack}
          className="btn btn-outline-secondary rounded-pill px-4 me-3 mb-3"
        >
          Back
        </button>
        <button
          type="submit"
          className="btn pi-btn-gradient text-white rounded-pill px-5 py-2 fw-bold shadow-sm mb-3"
        >
          Submit Enrollment
        </button>
      </div>
    </>
  );
};

export default DentistEnrollmentServiceInfo;
